export default __webpack_public_path__ + "static/media/BestMeter.644a9e0a.svg";